module.exports = __webpack_public_path__ + "tooltip1.16bca23328220d3ca7bb.svg";


//////////////////
// WEBPACK FOOTER
// E:/Git_new/IVMS_PRO/web/src/assets/images/tooltip/tooltip1.svg
// module id = ../../../../../src/assets/images/tooltip/tooltip1.svg
// module chunks = styles